import { NgModule, ModuleWithProviders } from '@angular/core';

import { OffcanvasDirective } from './offcanvas.directive';

@NgModule({
  declarations: [OffcanvasDirective],
  exports: [OffcanvasDirective]
})
export class OffcanvasModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: OffcanvasModule, providers: [] };
  }
}
